<xemex-dialog-shell [title]="'installationGroups.create.title' | translate">
  <form [formGroup]="form" class="flex flex-col gap-4 p-2">
    @if (requiresPartnerSelection()) {
      <div>
        <xemex-partner-select
          [formControl]="partnerControl"
          [label]="'installationGroups.create.partnerLabel' | translate"
          [placeholder]="'installationGroups.create.partnerPlaceholder' | translate"
        />
        @if (partnerError()) {
          <span class="block mt-1 text-xs text-red-500">
            {{ 'installationGroups.create.noPartner' | translate }}
          </span>
        }
      </div>
    }

    <xemex-text-field
      formControlName="name"
      [label]="'installationGroups.create.name' | translate"
      [required]="true"
      [invalid]="form.controls['name'].invalid && form.controls['name'].touched"
      [errorText]="
        'error.required' | translate: { field: ('installationGroups.create.name' | translate) }
      "
    />

    <xemex-text-field
      formControlName="description"
      [label]="'installationGroups.create.description' | translate"
    />
  </form>

  <mat-dialog-actions actions>
    <xemex-filled-button type="button" (click)="onCreate()">
      {{ 'general.btnCreate' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button type="button" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
